export default "__VITE_ASSET__CnuEYQrP__"